import { Outlet, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { MobileBottomNavV2 } from '@/components/mobile/MobileBottomNavV2';
import { MobileHeader } from '@/components/mobile/MobileHeader';
import { MobilePageTransition } from '@/components/mobile/MobilePageTransition';

export default function MobileLayout() {
  const location = useLocation();

  const isDetailRoute = (
    location.pathname.startsWith('/m/leads/') ||
    location.pathname.startsWith('/m/contacts/') ||
    location.pathname.startsWith('/m/deals/') ||
    location.pathname.startsWith('/m/cases/')
  );
  const hideNavigation = false;

  useEffect(() => {
    const clearInteractionLocks = () => {
      document.documentElement.style.pointerEvents = '';
      document.body.style.pointerEvents = '';
      document.documentElement.removeAttribute('data-scroll-locked');
      document.body.removeAttribute('data-scroll-locked');
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      document.body.style.paddingRight = '';
    };

    clearInteractionLocks();
    const t1 = window.setTimeout(clearInteractionLocks, 50);
    const t2 = window.setTimeout(clearInteractionLocks, 180);
    const t3 = window.setTimeout(clearInteractionLocks, 360);

    return () => {
      window.clearTimeout(t1);
      window.clearTimeout(t2);
      window.clearTimeout(t3);
    };
  }, [location.pathname]);

  const title = (() => {
    if (location.pathname === '/m/' || location.pathname === '/m') return 'Inicio';
    if (location.pathname.startsWith('/m/dashboard')) return 'Dashboard';
    if (location.pathname.startsWith('/m/leads')) return 'Leads';
    if (location.pathname.startsWith('/m/contacts')) return 'Contatos';
    if (location.pathname.startsWith('/m/deals')) return 'Negocios';
    if (location.pathname.startsWith('/m/whatsapp')) return 'Mensagens';
    if (location.pathname.startsWith('/m/tasks')) return 'Tarefas';
    if (location.pathname.startsWith('/m/calls')) return 'Chamadas';
    if (location.pathname.startsWith('/m/profile')) return 'Perfil';
    if (location.pathname.startsWith('/m/cases')) return 'Cases';
    if (location.pathname.startsWith('/m/customer-service')) return 'Atendimento';
    if (location.pathname.startsWith('/m/knowledge-base')) return 'Knowledge Base';
    if (location.pathname.startsWith('/m/reports')) return 'Relatorios';
    if (location.pathname.startsWith('/m/onboarding')) return 'Onboarding';
    if (location.pathname.startsWith('/m/announcements')) return 'Avisos';
    if (location.pathname.startsWith('/m/service-detail')) return 'Servico';
    return 'Divus';
  })();

  const backTo = (() => {
    if (location.pathname.startsWith('/m/leads/')) return '/m/leads';
    if (location.pathname.startsWith('/m/contacts/')) return '/m/contacts';
    if (location.pathname.startsWith('/m/deals/')) return '/m/deals';
    if (location.pathname.startsWith('/m/cases/')) return '/m/cases';
    return undefined;
  })();

  return (
    <div className="h-app flex flex-col overflow-hidden bg-background">
      <MobileHeader title={title} showBack={isDetailRoute} backTo={backTo} />
      <main className={`flex-1 overflow-y-auto overscroll-contain [-webkit-overflow-scrolling:touch] ${hideNavigation ? 'pb-0' : 'pb-[var(--bottom-nav-total-height)]'}`}>
        <MobilePageTransition>
          <Outlet />
        </MobilePageTransition>
      </main>
      {!hideNavigation ? <MobileBottomNavV2 /> : null}
    </div>
  );
}
